import script from "./esAddTimeslot.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAddTimeslot.vue?vue&type=script&setup=true&lang=ts"

import "./esAddTimeslot.vue?vue&type=style&index=0&id=be786074&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be786074"]])

export default __exports__